/* eslint-disable @typescript-eslint/no-explicit-any */
import { GatsbyImage } from 'gatsby-plugin-image';
import { useEffect } from 'react';

import { withErrorBoundary } from '../ErrorBoundary';
import Video from '../Video';

import {
  StyledCaption,
  StyledColoredBox,
  StyledEmbedly,
  StyledHeadingAndDescriptionWrapper,
  StyledImageWrapper,
  StyledMediaWrapper,
  StyledModuleDescription,
  StyledModuleHeading,
  StyledWrapper,
} from './Styled';

interface Media {
  title?: string;
  shortDescription?: string;
  caption?: string;
  image?: any;
  videoUrl?: string;
  halfWidthImage?: boolean;
  embedlyContent?: string;
}

// TODO split into seperate embed and media component
const Media = ({ title, shortDescription, image, caption, halfWidthImage, videoUrl, embedlyContent }: Media) => {
  const specificImage = image?.asset?.landscapeImage || image?.asset?.portraitImage || image?.asset?.squareImage;

  useEffect(() => {
    if (typeof window !== 'undefined' && embedlyContent && embedlyContent.length > 0) {
      // eslint-disable
      const initEmbedly = (w: any, d: any) => {
        const id = 'embedly-platform',
          n = 'script';
        if (!d.getElementById(id)) {
          w.embedly =
            w.embedly ||
            function () {
              // eslint-disable-next-line prefer-rest-params
              (w.embedly.q = w.embedly.q || []).push(arguments);
            };
          const e = d.createElement(n);
          e.id = id;
          e.async = 1;
          // this trick is required to make size of player more adequate
          e.onload = () => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            if (window.embedly) {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              window.embedly('on', 'card.rendered', (iframe: any) => {
                const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
                if (iframeDocument) {
                  const playerWrapper = iframeDocument.getElementsByClassName('resp-media');

                  if (playerWrapper.length) {
                    playerWrapper[0].style.paddingBottom = '';
                  }
                }
              });
            }
          };
          e.src =
            (document.location.protocol === 'https:' ? 'https' : 'http') + '://cdn.embedly.com/widgets/platform.js';
          const s = d.getElementsByTagName(n)[0];
          s.parentNode.insertBefore(e, s);
        }
      };
      initEmbedly(window, document);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <StyledWrapper className="media">
      <StyledHeadingAndDescriptionWrapper>
        {title && <StyledModuleHeading>{title}</StyledModuleHeading>}
        {shortDescription && <StyledModuleDescription>{shortDescription}</StyledModuleDescription>}
      </StyledHeadingAndDescriptionWrapper>
      {embedlyContent && embedlyContent.length > 0 ? (
        <StyledEmbedly dangerouslySetInnerHTML={{ __html: embedlyContent }} />
      ) : (
        <>
          <StyledColoredBox />
          <StyledMediaWrapper>
            <StyledImageWrapper halfWidthImage={halfWidthImage}>
              {specificImage && <GatsbyImage image={specificImage} alt={image.alt ? image.alt : image.title} />}
              {!image && videoUrl && <Video videoUrl={videoUrl} />}
            </StyledImageWrapper>
          </StyledMediaWrapper>
          {caption && <StyledCaption>{caption}</StyledCaption>}
        </>
      )}
    </StyledWrapper>
  );
};

export default withErrorBoundary(Media, { componentName: 'Media' });
